/* Pub-Sub event bus — ported from Shopify Dawn theme for 3rd-party app compatibility.
   Exposes window.subscribe / window.publish globally since EC scripts load without ES modules. */
(function(){
  var subscribers = {};

  function subscribe(eventName, callback){
    if (subscribers[eventName] === undefined){
      subscribers[eventName] = [];
    }
    subscribers[eventName] = subscribers[eventName].concat([callback]);
    return function unsubscribe(){
      subscribers[eventName] = subscribers[eventName].filter(function(cb){ return cb !== callback; });
    };
  }

  function publish(eventName, data){
    if (subscribers[eventName]){
      var promises = subscribers[eventName].map(function(callback){ return callback(data); });
      return Promise.all(promises);
    }
    return Promise.resolve();
  }

  window.subscribe = subscribe;
  window.publish = publish;
})();
